
import {PropertyBase} from "./PropertyBase";
import {IconData, IconDialog} from "PageBuilder/utils/Dialogs/IconDialog";
declare let rednaoPDFInvoiceParams:any;

export class IconProperty extends PropertyBase{


    public label:string='Icon';
    private elementID:string;
    protected InternalGetElement(): JQuery {
        let option:IconData= this.GetOptionValue();
        let $element= jQuery(`<div style="cursor:pointer;width: 100%;text-align: center;"><span style="border:1px solid black;font-family: FontAwesome;font-size:100px;line-height: 100px;">${option.value}</span></div>`);
        $element.find('span').click(()=>this.SelectIcon());
        return $element;
    }

    protected InternalGenerationCompleted($element: JQuery) {

    }


    private async SelectIcon() {
        let result=await IconDialog.ShowAsync();
        if(result==null)
            return;

        this.$element.find('span').html(result.value);
        this.SetOptionValue(result);
    }

    public SubRenderer(): React.ReactNode {
        return undefined;
    }
}

